export const MEASUREMENT_LABELS = {
  weight_kg:     'Вес',
  chest_cm:      'Грудь',
  bicep_cm:      'Бицепс',
  waist_cm:      'Талия',
  abdomen_cm:    'Живот',
  hips_cm:       'Бёдра',
  thigh_cm:      'Бедро',
  above_knee_cm: 'Над коленом',
  calf_cm:       'Голень',
  body_fat_pct:  '% жира',
};

export const MEASUREMENT_HINTS = {
  weight_kg:     'Утром, натощак, после туалета',
  chest_cm:      'Самая широкая часть груди',
  bicep_cm:      'Рука опущена вниз и расслаблена — самая широкая часть',
  waist_cm:      'Самая узкая часть, живот расслаблен',
  abdomen_cm:    'Низ живота — проблемная зона',
  hips_cm:       'Между лобковой костью и серединой ягодицы — самая выпуклая часть',
  thigh_cm:      'Самая широкая часть бедра',
  above_knee_cm: 'Отступи 1-2 пальца выше коленной чашечки вверх — самая широкая часть',
  calf_cm:       'Самая широкая часть голени',
  body_fat_pct:  '% жира (по калиперу)',
};

export const MEASUREMENT_UNITS = { weight_kg: 'кг', body_fat_pct: '%' };
export const getUnit = (field) => MEASUREMENT_UNITS[field] || 'см';

export const FIELD_ORDER = [
  'weight_kg',
  'chest_cm', 'bicep_cm', 'waist_cm', 'abdomen_cm',
  'hips_cm', 'thigh_cm', 'above_knee_cm', 'calf_cm',
  'body_fat_pct',
];

export const MEASUREMENT_GROUPS = {
  'Основные':     ['weight_kg', 'body_fat_pct'],
  'Верх':         ['chest_cm', 'bicep_cm'],
  'Средняя зона': ['waist_cm', 'abdomen_cm'],
  'Низ':          ['hips_cm', 'thigh_cm', 'above_knee_cm', 'calf_cm'],
};

// 7 уровней активности по Алёне — с подробными описаниями
export const ACTIVITY_LEVELS = [
  {
    value: '1.2',
    label: '1.2 — Минимальная активность',
    desc: 'Сидячая работа (офис, за компьютером, кассир). Нет тренировок или почти нет. Шаги в день: менее 5000. Хобби: сериалы, чтение, пассивный отдых.',
  },
  {
    value: '1.375',
    label: '1.375 — Небольшая активность',
    desc: 'Сидячая работа + 1-3 лёгкие тренировки в неделю (йога, стретчинг, прогулки). Шаги в день: 5000-7000. Хобби: спокойные прогулки, лёгкий спорт по выходным.',
  },
  {
    value: '1.46',
    label: '1.46 — Средняя активность',
    desc: 'Работа средней подвижности (продавец, учитель) или сидячая + регулярные тренировки 3-4 раза в неделю. Шаги: 7000-10000. Хобби: танцы, плавание, велосипед, бассейн.',
  },
  {
    value: '1.55',
    label: '1.55 — Выше среднего',
    desc: 'Интенсивные тренировки 5-6 раз в неделю или активная работа + тренировки. Шаги: 10000-12000. Хобби: баскетбол, футбол, командные виды спорта, бег.',
  },
  {
    value: '1.64',
    label: '1.64 — Повышенная активность',
    desc: 'Ежедневные тренировки + физическая работа (официант, медсестра, почтальон, воспитатель). Шаги: 12000-15000. Активный образ жизни каждый день.',
  },
  {
    value: '1.725',
    label: '1.725 — Высокая активность',
    desc: 'Ежедневные интенсивные тренировки + тяжёлая физическая работа + много ходьбы. Шаги: более 15000. Работа: строитель, грузчик, спортивный тренер с несколькими группами.',
  },
  {
    value: '1.9',
    label: '1.9 — Очень высокая активность',
    desc: 'Профессиональный спортсмен. Тренировки 2 раза в день, тяжёлый физический труд ежедневно. Встречается редко.',
  },
];

export const GOAL_LABELS = {
  weight_loss:  'Похудение',
  muscle_gain:  'Набор мышечной массы',
  maintenance:  'Поддержание формы',
};

export const TRAINING_EXPERIENCE_LABELS = {
  none:         'Не тренируюсь',
  beginner:     'Новичок (до 6 месяцев)',
  intermediate: 'Средний уровень (6 мес — 2 года)',
  advanced:     'Продвинутый (более 2 лет)',
};

export const TRAINING_FREQUENCY_LABELS = {
  none: 'Не тренируюсь',
  '1-2': '1-2 раза в неделю',
  '3-4': '3-4 раза в неделю',
  '5+':  '5 и более раз в неделю',
};

export function formatDelta(delta, field) {
  if (delta === 0 || delta === null) return '0';
  const sign = delta > 0 ? '+' : '';
  return `${sign}${delta} ${getUnit(field)}`;
}
